export const API_BASE_URL = "https://admin.eastend.in/api/";
export const MEDIA_URL = "https://admin.eastend.in/media/";
export const THUMB_URL = "https://admin.eastend.in/thumb/";
export const MAP_KEY = "AIzaSyCoglsXjfzu0bazOif79wgBcQ-C54I4LV4";